import { signal } from '@preact/signals'
import { apiBase } from './region'
import { sessionToken } from './auth'
import { lang } from '../i18n'

/**
 * Согласие на обработку данных (152-ФЗ, docs/legal-review.md §7).
 *
 * Версия привязана к редакции политики: сменилась — согласие берём заново. То же значение
 * держит сервер (`accounts.ts POLICY_VERSION`); расходиться им нельзя, иначе клиент будет
 * слать согласие под версией, которую сервер не признаёт.
 */
export const POLICY_VERSION = '2026-10-19'

/** Сервер сказал, что у вошедшего аккаунта нет согласия под текущей редакцией: нужен экран. */
export const needsConsent = signal(false)

export interface ConsentInput {
  policyVersion: string
  terms: boolean
  childData: boolean
}

/** Согласие, которое шлётся вместе с запросом кода при регистрации. */
export function consentPayload(): ConsentInput {
  return { policyVersion: POLICY_VERSION, terms: true, childData: true }
}

/**
 * «Догоняющее» согласие уже вошедшего аккаунта (старый аккаунт или новая редакция).
 * Регион берётся тот, что выбран на устройстве. Успех снимает флаг.
 */
export async function submitConsent(region: 'ru' | 'other'): Promise<boolean> {
  const token = sessionToken()
  if (token === null) return false
  try {
    const response = await fetch(`${apiBase()}/account/consent`, {
      method: 'POST',
      headers: { 'content-type': 'application/json', authorization: `Session ${token}` },
      body: JSON.stringify({ policyVersion: POLICY_VERSION, region, locale: lang.value, channel: 'web' }),
    })
    if (!response.ok) return false
    needsConsent.value = false
    return true
  } catch {
    return false
  }
}
